const find = {
  vehicleCategory: {
    method: 'get',
    url: '/client/utils/find/vehicle-category'
  }
}

export default {
  find,
  journeyAlerts: {
    method: 'get',
    url: '/client/utils/journey-alerts'
  }
}
